module.exports = __webpack_public_path__ + "static/img/logo.4d839c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bamei/logo.png
// module id = Dznl
// module chunks = 71